import BeetAPI from '@boite-beet/api-client'
import { createGtm } from '@gtm-support/vue-gtm'
import axios from 'axios'
import { createApp } from 'vue'

import App from '@/App.vue'
import langRouter from '@/extentions/langRouter'
import i18n from '@/i18n'
import router from '@/router'
import store from '@/store'
import '@/styles/app.scss'

const app = createApp(App)
  .use(i18n)
  .use(store)
  .use(router)
  .use(langRouter, 'fr')
  .use(BeetAPI, { store, apiUrl: import.meta.env.VITE_APP_API_URL })

const gtm = import.meta.env.VITE_APP_GTM
if (gtm) {
  app.use(
    createGtm({
      id: gtm,
      defer: true,
      enabled: false,
      vueRouter: router,
    }),
  )
}

axios('/icons.svg').then(({ data }) => document.body.insertAdjacentHTML('afterbegin', data))

app.mount('#app')
